import { loadAudioEye } from './util/audioeye-helpers';

export default function () {
    loadAudioEye();
}
